import React from "react";
import { Datagrid, DeleteButton, EditButton, List, TextField } from "react-admin";
import { PUBLISHED_ENTITY_COLOR, UNPUBLISHED_ENTITY_COLOR } from "../../utils";

// Edit + (conditional) Delete grouped in one cell, ~10px apart.
// Delete renders only for styles with 0 linked classes (also enforced server-side).
const RowActions = ({ record }) => (
  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
    <EditButton record={record} color="secondary" basePath="/classStyles" />
    {record && Number(record.classCount) === 0 && (
      <DeleteButton
        record={record}
        basePath="/classStyles"
        resource="classStyles"
        mutationMode="pessimistic"
        redirect={false}
        confirmTitle={`Delete style "${record.name}"?`}
        confirmContent="This style has no linked classes. Deleting it is permanent."
      />
    )}
  </div>
);

export function ClassStyleList(props) {
  return (
    <List
      {...props}
      perPage={25}
      sort={{ field: "sortIndex", order: "ASC" }}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField source="sortIndex" label="Sort Index" />
        <TextField source="name" />
        <TextField source="slug" label="Slug" />
        <TextField source="classCount" label="# Classes" />
        <RowActions label="" />
      </Datagrid>
    </List>
  );
}

function rowStyle(record) {
  return { backgroundColor: record.hidden ? UNPUBLISHED_ENTITY_COLOR : PUBLISHED_ENTITY_COLOR };
}
